module.exports = __webpack_public_path__ + "assets/img/push.b6de9946.svg";